/**
 * @file   : AdvertWrapped.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 1/7/2019, 3:00:53 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import HighlightContainer, {
  HIGHLIGHT_NOTIFICATION,
} from '../../../external/components/container/HighlightContainer'
import Cont, { ALIGN_CENTER } from '../../../external/components/layout/Cont'
import Advert, { getAdObj } from './Advert'

const AdvertWrapped = ({
  id,
  adConfig,
  hideXS = false,
  hideSM = false,
  hideMD = false,
  hideLG = false,
  pageMetaData = {},
  parentInitComplete = true,
}) => {
  if (!getAdObj(id, adConfig)) {
    return null
  }

  return (
    <Cont
      hideXS={hideXS}
      hideSM={hideSM}
      hideMD={hideMD}
      hideLG={hideLG}
      hideInPrint
    >
      <HighlightContainer style={HIGHLIGHT_NOTIFICATION} overridePadLR>
        <Cont align={ALIGN_CENTER}>
          <Advert
            id={id}
            adConfig={adConfig}
            pageMetaData={pageMetaData}
            parentInitComplete={parentInitComplete}
          />
        </Cont>
      </HighlightContainer>
    </Cont>
  )
}

AdvertWrapped.propTypes = {
  id: PropTypes.string.isRequired,
  adConfig: PropTypes.object.isRequired,
  hideXS: PropTypes.bool,
  hideSM: PropTypes.bool,
  hideMD: PropTypes.bool,
  hideLG: PropTypes.bool,
  pageMetaData: PropTypes.object,
  parentInitComplete: PropTypes.bool,
}

export default AdvertWrapped
